import React from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";

import rem from "utils/rem";

interface Props {
  theme: string | (() => void);
  toggleTheme: any;
}

const Toggle = ({ theme, toggleTheme }: Props) => {
  return (
    <Container>
      <Label>Theme</Label> <Button onClick={toggleTheme}>{theme}</Button>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1;
`;

const Button = styled.button`
  background: ${({ theme }) => theme.background};
  border: ${rem(2)} solid ${({ theme }) => theme.toggleBorder};
  color: ${({ theme }) => theme.text};
  border-radius: 1rem;
  cursor: pointer;
  font-size: 0.8rem;
  margin-left: 0.2rem;
  padding: 0.4rem 0.6rem;
  outline: 0;
  text-transform: capitalize;
  width: 4rem;

  ${breakpoint("tablet")`
    margin-top: 0.2rem;
  `}
`;

const Label = styled.span`
  color: ${({ theme }) => theme.text};

  ${breakpoint("tablet")`
    color: ${({ theme }) => theme.toggleText};
  `}
`;

export default Toggle;
